import { ValidationErrors } from 'final-form';

const filterFormErrors = (
  errors: ValidationErrors,
  touched: { [key: string]: boolean } = {}
) =>
  Object.keys(errors).reduce((acc, key) => {
    const isTouched = !!touched[key];
    const errorMessage = errors[key];

    return { ...acc, ...(isTouched && { [key]: errorMessage }) };
  }, {});

export default filterFormErrors;
